var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('van-loading',{staticClass:"loading",attrs:{"type":"spinner","vertical":"","color":"#1989fa"}}):_c('div',{staticClass:"message"},[_c('div',[_vm._v(_vm._s(_vm.message))]),(_vm.btnShow)?_c('van-button',{staticClass:"button",attrs:{"type":"primary"},on:{"click":_vm.retry}},[_vm._v("点击重试")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }